// Add padding bottom when Header CTA sticks to bottom
function applyPadding() {
  if (window.innerWidth <= 749) {
    document.body.style.paddingBottom = "72px";
  } else {
    document.body.style.paddingBottom = "0px";
  }
}
applyPadding();
window.addEventListener('resize', applyPadding);


function updateMenuStyle() {
  if (window.innerWidth > 749) {
    document.querySelector(".header").dataset.menuStyle = "menu";
  } else {
    document.querySelector(".header").dataset.menuStyle = "drawer";
  }
}
updateMenuStyle();
window.addEventListener("resize", updateMenuStyle);

// const body = document.body;
// const toggle = document.querySelector(".theme_toggle");

// const layoutElements = [
//   document.querySelector(".header__row"),
//   document.querySelector("footer .section-background"),
//   document.querySelector("footer .section"),
//   document.querySelector(".footer-utilities .section-background"),
//   document.querySelector(".footer-utilities .section")
// ];

// // Toggle Class function
// function toggleClass(element, isInverse) {
//   if (!element) return;

//   const defaultClass = element.dataset.default;
//   const inverseClass = element.dataset.inverse;

//   if (!defaultClass || !inverseClass) return;

//   element.classList.remove(defaultClass, inverseClass);
//   element.classList.add(isInverse ? inverseClass : defaultClass);
// }

// // Toggle Event
// if (toggle) 
// {
//   toggle.addEventListener("click", () => {
//     const isInverse = body.classList.toggle("inverse");

//     // Apply body theme to <main>
//     const main = document.querySelector("main");
//     if (main) {
//       const bodyDefault = body.dataset.default;
//       const bodyInverse = body.dataset.inverse;

//       if (bodyDefault && bodyInverse) {
//         main.classList.remove(bodyDefault, bodyInverse);
//         main.classList.add(isInverse ? bodyInverse : bodyDefault);
//       }
//     }

//     layoutElements.forEach(el => {
//       toggleClass(el, isInverse);
//     });

//     const customSections = document.querySelectorAll(".custom_section");

//     customSections.forEach(section => {
//       const isCustom = section.dataset.custom === "true";

//       if (isCustom) {
//         toggleClass(section, isInverse);
//       } else {
//         const bodyDefault = body.dataset.default;
//         const bodyInverse = body.dataset.inverse;

//         if (!bodyDefault || !bodyInverse) return;

//         section.classList.remove(bodyDefault, bodyInverse);
//         section.classList.add(isInverse ? bodyInverse : bodyDefault);
//       }
//     });
//   });
// }


// document.addEventListener("DOMContentLoaded", () => {

  const body = document.body;
  const toggle = document.querySelector(".theme_toggle");

  const layoutElements = [
    document.querySelector(".header__row"),
    document.querySelector("footer .section-background"),
    document.querySelector("footer .section"),
    document.querySelector(".footer-utilities .section-background"),
    document.querySelector(".footer-utilities .section")
  ];

  function toggleClass(element, isInverse) {
    if (!element) return;

    const defaultClass = element.dataset.default;
    const inverseClass = element.dataset.inverse;

    if (!defaultClass || !inverseClass) return;

    element.classList.remove(defaultClass, inverseClass);
    element.classList.add(isInverse ? inverseClass : defaultClass);
  }

  function applyTheme(isInverse) {
    // ✅ Apply to <body>
    body.classList.toggle("inverse", isInverse);

    // ✅ Apply to <main>
    const main = document.querySelector("main");
    if (main) {
      const bodyDefault = body.dataset.default;
      const bodyInverse = body.dataset.inverse;

      if (bodyDefault && bodyInverse) {
        main.classList.remove(bodyDefault, bodyInverse);
        main.classList.add(isInverse ? bodyInverse : bodyDefault);
      }
    }

    // ✅ Layout elements
    layoutElements.forEach(el => toggleClass(el, isInverse));

    // ✅ Sections
    const customSections = document.querySelectorAll(".custom_section");

    customSections.forEach(section => {
      const isCustom = section.dataset.custom === "true";

      if (isCustom) {
        toggleClass(section, isInverse);
      } else {
        const bodyDefault = body.dataset.default;
        const bodyInverse = body.dataset.inverse;

        if (!bodyDefault || !bodyInverse) return;

        section.classList.remove(bodyDefault, bodyInverse);
        section.classList.add(isInverse ? bodyInverse : bodyDefault);
      }
    });
  }

  // ✅ APPLY SAVED THEME ON LOAD
  const savedTheme = localStorage.getItem("theme");
  applyTheme(savedTheme === "inverse");

  // ✅ TOGGLE CLICK
  if (toggle) {
    toggle.addEventListener("click", () => {
      const isInverse = !body.classList.contains("inverse");

      localStorage.setItem("theme", isInverse ? "inverse" : "default");

      applyTheme(isInverse);
    });
  }

// });

